import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';
import { useCompleteOperationModal } from '../context/CompleteOperationModalContext';

const CompleteOperationModalHeader: FC = () => {
  const { t } = useTranslate();
  const { actions } = useCompleteOperationModal();

  return (
    <Modal.Header>
      <Modal.Title>{t('CompleteOperation')}</Modal.Title>
      <button
        type="button"
        className="close"
        onClick={actions.handleCloseModal}
      >
        <em className="icon ni ni-cross" />
      </button>
    </Modal.Header>
  );
};

export default CompleteOperationModalHeader;
